import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageService } from 'src/app/services/account/language.service';
import { SvgRecolorDirective } from 'src/app/directives/svg-recolor.directive';

/**
 * "A shorter route is available" offer, rendered as a state of the navigation
 * plan card (the same way the charging stop takes the card over) instead of a
 * separate floating popup.
 */
@Component({
  standalone: true,
  selector: 'app-navigation-plan-better-route',
  templateUrl: './navigation-plan-better-route.component.html',
  styleUrls: ['./navigation-plan-better-route.component.scss'],
  imports: [CommonModule, SvgRecolorDirective]
})
export class NavigationPlanBetterRouteComponent {
  @Input() message: string = '';
  /** Auto-dismiss timeout, drives the countdown strip's animation length. */
  @Input() timeoutMs: number = 0;

  @Output() acceptClick = new EventEmitter<void>();
  @Output() dismissClick = new EventEmitter<void>();

  constructor(public languageService: LanguageService) {}

  public onAccept(): void {
    this.acceptClick.emit();
  }

  public onDismiss(): void {
    this.dismissClick.emit();
  }
}
